import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const NyuryokuFileFormatKbn = props => {
  return <Dropdown.Static kubunKey='nyuryoku_file_format_kbn' {...props} />
}
